import React from 'react';
import { useFormik } from 'formik';

import { SupportForm } from '../components/SupportForm';
import { Save } from '../../../widgets/Save';
import { ShopDetailsType } from '../../shops/service/shop.interface';
import { useUpdateShopDetailsMutation } from '../../shops/service/shops';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { validationSchema } from '../utils/validationSchema';
import { SupportProps } from '../service/support.interface';

export const SupportEditContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const [updateShopDetails, { isSuccess, isError, isLoading, data, error }] =
        useUpdateShopDetailsMutation();

    useApiSuccessNotification(isSuccess, data, null, true);
    useApiErrorNotification(isError, error);

    const onSave = async () => {
        const payload = {
            type: ShopDetailsType.contactInfo,
            value: formik.values.link,
        };

        await updateShopDetails({
            id: +current.id,
            body: payload,
        });
    };

    const formik = useFormik<SupportProps>({
        initialValues: {
            link: current?.details?.contact_info,
        },
        validateOnBlur: true,
        validationSchema,
        onSubmit: onSave,
    });

    return (
        <>
            <SupportForm formik={formik} />
            <Save
                loading={isLoading}
                disabled={isLoading || !formik.isValid || !formik.dirty}
                onSave={onSave}
            />
        </>
    );
};
